module.exports = __webpack_public_path__ + "img/share-account.78105fe2.svg";